module.exports = __webpack_public_path__ + "img/analytic_chat.0b0d5230.svg";